interface WizardProgressProps {
  /** Total number of steps. */
  steps: number;
  /** Current step, 1-based. */
  current: number;
}

/** Segmented wizard progress bar — segments up to the current step run red. */
export function WizardProgress({ steps, current }: WizardProgressProps) {
  return (
    <div
      aria-label={`Step ${current} of ${steps}`}
      aria-valuemax={steps}
      aria-valuemin={1}
      aria-valuenow={current}
      className="rfp-wizard"
      role="progressbar"
    >
      {Array.from({ length: steps }, (_, index) => (
        <span
          className={
            index < current
              ? 'rfp-wizard__segment rfp-wizard__segment--active'
              : 'rfp-wizard__segment'
          }
          key={index}
        />
      ))}
    </div>
  );
}
